import { rankingThumbRadius } from "./rankingAssetDimensions";

/** Shared layout constants for LivestreamRankingTable. */
export const RANKING_TABLE_HEIGHT_PX = 780;
export const RANKING_TABLE_HEADER_HEIGHT_PX = 20;
export const RANKING_TABLE_HEADER_TO_ROWS_GAP_PX = 10;
export const RANKING_TABLE_DATA_AREA_HEIGHT_PX =
  RANKING_TABLE_HEIGHT_PX -
  RANKING_TABLE_HEADER_HEIGHT_PX -
  RANKING_TABLE_HEADER_TO_ROWS_GAP_PX;
export const RANKING_TABLE_ROW_GAP_PX = 10;
export const RANKING_TABLE_DATA_ROW_HEIGHT_PX =
  (RANKING_TABLE_DATA_AREA_HEIGHT_PX - 9 * RANKING_TABLE_ROW_GAP_PX) / 10;

export const RANKING_TABLE_RANK_TITLE_FONT_PX = 24;
export const RANKING_TABLE_METRIC_FONT_PX = 24;
export const RANKING_TABLE_HEADER_LABEL_FONT_PX = 16;
export const RANKING_TABLE_RANK_COL_WIDTH_PX = 28;
export const RANKING_TABLE_THUMB_PX = 50;
export const RANKING_TABLE_THUMB_RADIUS = `${rankingThumbRadius(RANKING_TABLE_THUMB_PX)}px`;
export const RANKING_TABLE_ROW_INNER_GAP_PX = "8px";
export const RANKING_TABLE_METRIC_COL_WIDTH_PX = 100;

export const rankingTableRowCardBaseSx = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  px: "20px",
  py: 0,
  borderRadius: "20px",
  bgcolor: "rgba(33,35,45,0.7)",
  boxSizing: "border-box" as const,
  height: RANKING_TABLE_DATA_ROW_HEIGHT_PX,
  minHeight: RANKING_TABLE_DATA_ROW_HEIGHT_PX,
  maxHeight: RANKING_TABLE_DATA_ROW_HEIGHT_PX,
  flexShrink: 0,
} as const;

export const rankingTableHeaderRowSx = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  px: "20px",
  py: 0,
  height: RANKING_TABLE_HEADER_HEIGHT_PX,
  minHeight: RANKING_TABLE_HEADER_HEIGHT_PX,
  maxHeight: RANKING_TABLE_HEADER_HEIGHT_PX,
  borderRadius: "20px",
  boxSizing: "border-box" as const,
  flexShrink: 0,
} as const;

export const rankingTableHeaderLabelSx = {
  fontFamily: '"DM Sans", sans-serif',
  fontWeight: 600,
  color: "rgba(255,255,255,0.88)",
} as const;

/** Marks title nodes that should render without ellipsis in PNG capture clones. */
export const RANKING_CAPTURE_FULL_TEXT_ATTR = "data-ranking-capture-full-text";

/** Row/card shell overrides when titles may wrap to multiple lines on export. */
export const rankingTableCaptureRowShellSx = {
  height: "auto",
  maxHeight: "none",
} as const;
